<template>
  <div>
    <AppHeader />

    <router-view/>

    <AppFooter />
  </div>
</template>

<style>
:root {
  --main: #ffd300;
  --main-hover: #ffd500c4;
  --main-active: #b49d28;
  --black: #000;
  --white: #fff;
}

@font-face {
  font-family: "Montserrat";
  src: url("@/assets/fonts/montserrat-medium-webfont.woff2") format("woff2"),
    url("@/assets/fonts/montserrat-medium-webfont.woff") format("woff");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Montserrat";
  src: url("@/assets/fonts/montserrat-regular-webfont.woff2") format("woff2"),
    url("@/assets/fonts/montserrat-regular-webfont.woff") format("woff");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Montserrat";
  src: url("@/assets/fonts/montserrat-semibold-webfont.woff2") format("woff2"),
    url("@/assets/fonts/montserrat-semibold-webfont.woff") format("woff");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Roboto";
  src: url("@/assets/fonts/roboto-light-webfont.woff2") format("woff2"),
    url("@/assets/fonts/roboto-light-webfont.woff") format("woff");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

* {
  box-sizing: border-box;
}

body,
html {
  margin: 0 auto;
  padding: 0;
  max-width: 1920px;
  background-color: #f5f1f1;
  font-family: "Montserrat", Helvetica, sans-serif;
  font-size: 20px;
  line-height: 24px;
  color: var(--black);
  scroll-behavior: smooth;
}

path {
  fill: inherit;
  stroke: inherit;
}

input[type="text"],
input[type="button"],
input[type="submit"],
input[type="email"],
input[type="tel"],
input[type="password"] {
  -webkit-appearance: none;
  border-radius: 0;
}

.active {
  transform: none !important;
}

.container {
  margin: 0 auto;
  padding: 0 30px;
  max-width: 1170px;
}

.section__container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.list-reset {
  padding: 0;
  margin: 0;
  list-style: none;
}

.link-reset {
  text-decoration: none;
  color: var(--black);
  outline: none;
}

.heading-reset {
  margin: 0;
}

.p-reset {
  margin: 0;
}

.btn-reset {
  padding: 0;
  border: none;
  background-color: transparent;
  cursor: pointer;
  outline: none;
}

.anchor {
  position: absolute;
  top: -50px;
  left: 0;
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
}

.section {
  position: relative;
  margin-bottom: 128px;
}

.section__heading {
  margin: 0;
  margin-bottom: 64px;
  font-size: 40px;
  font-weight: 500;
  line-height: 49px;
  text-transform: uppercase;
}

.section__heading span {
  position: relative;
}

.section__heading span::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  height: 5px;
  width: 70px;
  background-color: var(--main);
}

@media (max-width: 960px) {
  .section {
    margin-bottom: 80px;
  }
}

@media (max-width: 769px) {
  body,
  html {
    font-size: 18px;
    line-height: 20px;
  }

  .section__heading {
    font-size: 32px;
    margin-bottom: 30px;
  }
}

@media (max-width: 600px) {
  body,
  html {
    font-size: 14px;
    line-height: 18px;
  }

  .container {
    padding: 0 20px;
  }

  .section {
    margin-bottom: 50px;
  }

  .section__heading {
    font-size: 24px;
    line-height: 120%;
  }

  .section__heading span::before {
    height: 2px;
    width: 40px;
  }
}
</style>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
export default {
  components: {
    AppHeader,
    AppFooter
  },
  created () {
  }
}
</script>
